import React from "react";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";

function ImagePreviewModal({
  openPreviewImage,
  handleClosePreviewImage,
  selectedImage,
  customModalStyle = {},
}) {
  const imageHtmlString = selectedImage?.outerHTML;

  return (
    <Modal
      open={openPreviewImage}
      onClose={handleClosePreviewImage}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "background.paper",
          boxShadow: 24,
          cursor: "pointer",
          overflow: "hidden",
          width: "65vw",
          height: "85vh",
          ...customModalStyle,
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            backgroundColor: "black",
            padding: "10px",
          }}
        >
          <KeyboardBackspaceIcon
            style={{ color: "white" }}
            onClick={handleClosePreviewImage}
          />
          <CloseIcon
            style={{ color: "white" }}
            onClick={handleClosePreviewImage}
          />
        </div>

        <img
          src={selectedImage}
          alt="Selected"
          style={{ width: "100%", height: "100%", objectFit: "contain" }}
        />
      </Box>
    </Modal>
  );
}

export default ImagePreviewModal;
